export var ChunkType;
(function (ChunkType) {
    ChunkType["MESSAGE"] = "m";
    ChunkType["PROGRESS_STATUS"] = "progress_status";
    ChunkType["ERROR"] = "error";
})(ChunkType || (ChunkType = {}));
//# sourceMappingURL=types.js.map